var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-navbar',{staticClass:"bg-lightblack banner"},[_c('b-navbar-brand',{attrs:{"href":"#"}},[_c('img',{attrs:{"src":require("@/assets/logo.png"),"width":"40","height":"40"}}),_c('div',{staticClass:"d-inline-block align-middle ml-3"},[_c('h3',{staticClass:"text-gold d-inline"},[_vm._v("L'ANYVERS")])])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }